export { default } from './hakkimda';
